import firebase from 'firebase/app';
import 'firebase/auth'; // importing the auth module as an example
import 'firebase/database'; // importing the auth module as an example

const config = {
  apiKey: "AIzaSyDa4h0ZdhUqf6sRArYu49vokfIpKEFXJlk",
  authDomain: "forsaetisraduneytid-8e95c.firebaseapp.com",
  databaseURL: "https://forsaetisraduneytid-8e95c.firebaseio.com",
  projectId: "forsaetisraduneytid-8e95c",
  storageBucket: "forsaetisraduneytid-8e95c.appspot.com",
  messagingSenderId: "523699791598",
  appId: "1:523699791598:web:6f5a924c2bd0de0cf235ff"
}

let instance = null;

export default function getFirebase() {
  if (typeof window !== 'undefined') {
    if (instance) return instance;
    instance = firebase.initializeApp(config);
    return instance;
  }

  return null;
}